import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const TabPanel = ({ id, children, isActive, renderActiveTabsContentOnly }) => {
	const shouldRenderChildren = () => isActive || !renderActiveTabsContentOnly;
	const classes = classnames({ 'u-display-none': !isActive });
	return (
		<div id={id} className={classes} role="tabpanel" aria-labelledby={`tab-nav-${id}`}>
			{shouldRenderChildren() && children}
		</div>
	);
};

TabPanel.propTypes = {
	id: PropTypes.string.isRequired,
	children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
	isActive: PropTypes.bool,
	renderActiveTabsContentOnly: PropTypes.bool,
};

export default TabPanel;
